import { useEffect, useState } from 'react';
import { editor } from '@/instance';

/** 面板图层id */
export const usePanelLayerId = () => {
    const [layerId, setLayerId] = useState<string | null>(editor.active.getPick()?.id ?? null);

    useEffect(() => {
        const handler = editor.active.onChange((layer, pickLayer) => setLayerId((pickLayer || layer)?.id ?? null));
        return () => editor.off(handler);
    }, []);

    return layerId;
};

/** 组面板图层id */
export const useGroupPanelLayerId = () => {
    const [layerId, setLayerId] = useState<string | null>(editor.active.get()?.id ?? null);
    useEffect(() => {
        const handler = editor.active.onChange((layer) => setLayerId(layer?.id ?? null));
        return () => editor.off(handler);
    }, []);

    return layerId;
};
